import React, { useState, useEffect } from "react";
import Modal from "../../Common/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useContext } from "react";
import { RootContext } from "../../../index";
import { observer } from "mobx-react-lite";
import { useParams, useNavigate } from "react-router-dom";
import Form, { FormBody, TextInput } from '../../Common/Form';

const EditPlan = observer(() => {
  const rootStore = useContext(RootContext);
  const planStore = rootStore.planStore;

  const [caption, setCaption] = useState("");
  const [access_id, setAccessId] = useState("");
  const [password, setPassword] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!planStore.plan.length) planStore.fetchplan();
    const currentPlan = planStore.plan.find((plan) => plan.id === id);
    setCaption(currentPlan?.caption);
    setAccessId(currentPlan?.access_id);
    setPassword(currentPlan?.password);
  }, []);

  const editplan = async (e) => {
    e.preventDefault();
    if (!caption || !access_id) {
      toast.error("Missing fields");
      return;
    }
    const result = await planStore.editPlan(id, { caption: caption, access_id: access_id, password:password });
    if (result) {
      navigate("/configuration/plan")
      toast.success("Plan edited successfully");
    };
  };

  return (
    <>
      <Modal
        title={"Edit Plan Details"}
        closeModal={() => {
          navigate("/configuration/plan");
        }}
      >

        <Form>
          <FormBody>
            <TextInput label={'Caption'} name="caption" value={caption} onChange={(e) => setCaption(e.target.value)} />
            <TextInput label={'Access Id'} name="access_id" value={access_id} onChange={(e) => setAccessId(e.target.value)} />
            <TextInput label={'Password'} name="password" type="password" showToggle={true} value={password} onChange={(e) => setPassword(e.target.value)} />
            <br />
            <button onClick={editplan}>Submit</button>
          </FormBody>
        </Form>
      </Modal>
    </>
  );
});

export default EditPlan